import clsx from 'clsx'
import { formatSum, TSum } from '../../../../../utils/formatSum'

/**
 * @param amount - Фактическая сумма
 * @param expectedAmount - Ожидаемая/запрошенная сумма
 * @param isAmountChanged - Флаг, указывающий, что сумму нужно подсветить «красным».
 * @param className - Дополнительные классы для контейнера
 * @param showExpectedAmount - Отображать левую часть (ожидаемую сумму)
 * @param showAmount - Отображать ли правую часть (фактическую сумму)
 */
export const AmountCell = ({
  amount,
  expectedAmount,
  isAmountChanged = false,
  className = '',
  showExpectedAmount = true,
  showAmount = true,
}: {
  amount?: TSum
  expectedAmount?: TSum
  isAmountChanged: boolean
  className?: string
  showExpectedAmount?: boolean
  showAmount?: boolean
}) => {
  return (
    <td className={clsx(isAmountChanged && 'text-danger', className)}>
      {!!showExpectedAmount && <span>{expectedAmount ? formatSum(expectedAmount) : '-'}</span>}
      {!!(showExpectedAmount && showAmount) && <>&nbsp;/&nbsp;</>}
      {!!showAmount && <span>{amount ? formatSum(amount) : '-'}</span>}
    </td>
  )
}
